// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_6b0VoQ","container":"_1kV3rX"};